import BulkCreatePanel from './bulkCreatePanel.container';

export default BulkCreatePanel